import { Client, RuleClientPriority } from '@/app/models/client';
import { useSearchClientQuery } from '@/app/services/clientApi';
import { useSearchClientPriorityQuery } from '@/app/services/clientPriorityApi';
import GenericAutoComplete from '@/components/common/GenericAutoComplete';
import LateralDrawer from '@/components/common/LateralDrawer';
import PageTitle from '@/components/common/pageTitle';
import TextButton from '@/components/common/TextButton';
import NewEditPriorityProject from '@/components/priorityProjects/newEditPriorityProject';
import ProjectPriorityTable from '@/components/priorityProjects/ProjectPriorityTable';
import { Box, Typography, useTheme } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

function ProjectPriority() {
  const theme = useTheme();
  const [client, setClient] = useState<Client | null>(null);
  const [drawerStatus, setDrawerStatus] = useState(false);
  const [selectedRule, setSelectedRule] = useState<RuleClientPriority | null>(null);
  const { t } = useTranslation(['projectPriority', 'common']);

  const { data: clientsFiltered } = useSearchClientPriorityQuery({ searchTerm: client?.name || '' });

  const [clientSearch, setClientSearch] = useState('');
  const { data: clients, isFetching: isLoadingClients } = useSearchClientQuery(
    {
      searchTerm: clientSearch,
      page: 0,
      size: 10,
      sortKey: 'name',
      sortDirection: 'ASC',
    },
    { skip: clientSearch.length < 1 },
  );

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        mr: 2,
      }}
    >
      <PageTitle
        title={t('project.priority.title')}
        titleLabel={` (${t('project.priority.subtitle')})`}
        subtitle={t('project.priority.description') as string}
      />

      <Typography component="p" variant="fieldHeader">
        {t('client')}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          mb: 2,
          alignItems: 'center',
        }}
      >
        <GenericAutoComplete
          value={client}
          onChange={(value) => {
            setClient(value);
          }}
          equalityTest={(option, value) => option?.code === value?.code}
          getOptionLabel={(option) => `${option?.name}`}
          onSearch={(value) => {
            setClientSearch(value);
          }}
          options={clientSearch !== '' && clients?.content ? clients?.content : []}
          placeholder={t('enter.client.name') || ''}
          loading={isLoadingClients}
          sx={{ width: theme.spacing(50) }}
        />
        <TextButton
          sx={{ ml: 'auto' }}
          text={`+ ${t('new.priority')}`}
          onClick={() => {
            setSelectedRule(null);
            setDrawerStatus(true);
          }}
        />
      </Box>

      <ProjectPriorityTable
        rows={clientsFiltered || []}
        setSelectedItem={setSelectedRule}
        setDrawerOpen={setDrawerStatus}
      />

      <LateralDrawer open={drawerStatus} setOpen={setDrawerStatus} position="right" size="normal">
        <NewEditPriorityProject rule={selectedRule || null} setDrawerOpen={setDrawerStatus} />
      </LateralDrawer>
    </Box>
  );
}
export default ProjectPriority;
